import { memo } from 'react';
import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import NoticeBar from '@wconcept/wconcept-ui-renewal/components/molecules/_etc/NoticeBar';
import ToggleNotice from '@wconcept/wconcept-ui-renewal/components/molecules/_notice/ToggleNotice';
import CouponItem2Skeleton from '@wconcept/wconcept-ui-renewal/components/molecules/_skeleton/CouponItem2Skeleton';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

function resolveNoticeBarColorType(
  colorType: ColorType
): 'gray' | 'black' | 'opacity' {
  if (colorType === 'white') {
    return 'gray';
  }
  if (colorType === 'black') {
    return 'black';
  }
  return 'opacity';
}

function resolveSkeletonCouponBgType(
  isCustomColor: boolean,
  colorType: ColorType
): 'opacity' | 'black' | 'white' {
  if (isCustomColor) {
    return 'opacity';
  }
  if (colorType === 'black') {
    return 'black';
  }
  return 'white';
}

interface IProps {
  colorType?: ColorType;
  title?: string;
  subTitle?: string;
  isDesktop?: boolean;
  isLoaded?: boolean;
  noticeBarText?: React.ReactNode;
  noticeBarType?: string;
  couponList?: React.ReactNode;
  noticeList?: string[];
  onNoticeToggle?: (active: boolean) => void;
}

// 선착순 쿠폰으로 진행되는 프로모션성 쿠폰 리스트를 보여주는 컴포넌트
const CouponSection2 = ({
  colorType = 'white',
  title,
  subTitle,
  isDesktop,
  isLoaded,
  couponList,
  noticeBarText,
  noticeBarType,
  noticeList,
  onNoticeToggle,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;
  const couponSkeletonKeyList = isDesktop
    ? ['fcfs-coupon-skel-1', 'fcfs-coupon-skel-2', 'fcfs-coupon-skel-3']
    : ['fcfs-coupon-skel-1', 'fcfs-coupon-skel-2'];

  const cName = classNameBind([
    'coupon-list',
    !isCustomColor ? `bg-type-${colorType}` : '',
    Array.isArray(couponList) && couponList.length < 5 ? 'align-left' : '',
  ]);

  return (
    <S.CouponSection2
      className={cName}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
    >
      <ContTitle
        title={title}
        subTitle={subTitle}
        titleColor={customColors?.textColor}
        subTitleColor={customColors?.textColor}
      />

      {noticeBarText && (
        <NoticeBar
          text={noticeBarText}
          type={noticeBarType}
          colorType={resolveNoticeBarColorType(colorType)}
        />
      )}

      <div className="coupon-wrap">
        {!isLoaded
          ? couponSkeletonKeyList.map(skeletonKey => (
              <CouponItem2Skeleton
                key={skeletonKey}
                bgType={resolveSkeletonCouponBgType(isCustomColor, colorType)}
                bgColor={customColors?.bgColor}
              />
            ))
          : couponList}
      </div>

      {noticeList && (
        <ToggleNotice
          noticeList={noticeList}
          onNoticeToggle={onNoticeToggle}
          titleColor={customColors?.textColor}
          noticeColor={customColors?.textColor}
          hideBullet
        />
      )}
    </S.CouponSection2>
  );
};

export default memo(CouponSection2);
